import Resource from '../models/resource';
import Vue from 'vue';
import _ from "@helpers/_";
import cloneDeep from '../helpers/cloneDeep';

const offerDefault = {
  action: "sell",
  status: "open",
  fee_for: "fee_for_buy",
  currency: "ILS",
  based_on: "expiricence_short",
  give_as: "give_as_gift",
  group_ids: ["to_public"]
};

const resourceDefaultObject = {
  currentImageEditIndex: null,
  name: "",
  properties: "",
  images: [],
  categories: ["other"],
  offers: [Object.assign({}, offerDefault)]
};

const resourceState = {
  resourceDefault: Object.freeze(cloneDeep(resourceDefaultObject)),
  resourceDraft: new Resource(Object.create(resourceDefaultObject)),
  currentResource: null,
  myResources: [],
  resources: [],
  watchedResources: {}
};

const resourceActions = {
  async saveResource({ dispatch, commit }, { resource }) {
    const database = this._vm.firebase.database();
    const currentUserId = await dispatch("loggedInUserId");
    let ref = database.ref().child('resources');
    const isResourceNew = (resource.id == undefined);
    let newResourceRef = isResourceNew ? ref.push() : ref.child(resource.id);

    let resourceRecord = Object.assign({}, resource);

    resourceRecord.user_id = currentUserId;
    resourceRecord.updated_at = this._vm.firebase.database.ServerValue.TIMESTAMP;

    if (isResourceNew) {
      resourceRecord.created_at = this._vm.firebase.database.ServerValue.TIMESTAMP;
    }

    resourceRecord = _.omit(resourceRecord, ['user', 'image', 'diplay_offers', 'id']);

    resourceRecord.offers = resourceRecord.offers.map((offer) => {

      for (let key in offer) {
        if (offer[key] === undefined) {
          delete offer[key];
        }
      }
      if (offer.status === 'pending_delete') {
        offer.status = 'deleted';
      }
      return offer;

    });

    // resourceRecord.offers.map(offer => (offer.status === 'pending_delete'); offer)

    if (!resourceRecord.properties) {
      delete resourceRecord.properties;
    }

    await newResourceRef.set(resourceRecord);
    resourceRecord.id = newResourceRef.key;
    commit("RESET_RESOURCE_AND_SCROLL_STATE");
    return Promise.resolve(resourceRecord);
  },
  // resourceClick(store, resource) {
  //   store.commit('setCurrentResource', resource);
  //   this.$router.push({ name: 'show-resource', params: { resourceId: resource.id } });
  // },
  reportResource(store, content) {
    const database = this._vm.firebase.database();
    let report = {
      reported_item_id: store.state.currentResource.id,
      body: content,
      type: "resource",
      report_type: "report"
    };
    database.ref().child("reports").push().set(report);
  },
  watchMyResources({ commit }, { user_id }) {
    commit("resetMyResource");
    const database = this._vm.firebase.database();
    const resourcesRef = database.ref().child('resources');
    const ref = resourcesRef.orderByChild('user_id').equalTo(user_id);
    ref.on("child_added", (snap) => {
      let resource = new Resource(snap.val());
      resource.id = snap.key;
      if (resource.hasOffers()) {
        commit("setMyResource", resource);
        commit("setProfileStateLoaded");
      }
    });
  },
  watchResource(store, id) {
    if (store.state.watchedResources[id]) return;
    const database = this._vm.firebase.database();
    const ref = database.ref().child('resources').child(id);
    ref.on("value", (snap) => {
      let resource = snap.val();
      if (resource) {
        resource.id = id;
        store.commit("setWatchedResource", { id, resource });
      }
    });
  },
  async getResourceById({ commit, getters }, { id }) {
    let resourceData = getters.getCurrentResource;
    if (!resourceData || resourceData.id !== id) {
      const result = await this._vm.$http.get(`resource?id=${id}`);
      if (result.data.id) {
        resourceData = result.data;
        resourceData.id = id;
        commit("setCurrentResource", resourceData);
      }
    } else {
      commit("setCurrentResource", resourceData);
    }

  },
  addNewOffer({ commit }) {
    commit('addNewOffer');
  }
};

const resourceGetters = {
  isResourceDraftDirty(state) {
    return !state.resourceDraft.isEqual(state.resourceDefault);
  },
  getResourceDraftCategories: state => state.resourceDraft.categories,
  getResourceDraft: state => state.resourceDraft,
  getCurrentResource: (state) => {
    if (state.currentResource) return new Resource(state.currentResource);
    return null;
  },
  getMyResources: (state) => {
    const items = state.myResources.sort(function(a, b) {
      return b.created_at - a.created_at;
    });
    return items;
  },
};


const resourceMutations = {
  setWatchedResource(state, { id, resource }) {
    Vue.set(state.watchedResources, id, new Resource(resource));
  },
  clearDraftResource(state) {
    const clearResource = new Resource(state.resourceDefault);
    Vue.set(state, 'resourceDraft', clearResource);
  },
  resetMyResource(state) {
    state.myResources = [];
  },
  setMyResource(state, resource) {
    state.myResources.push(resource);
  },
  setIndexState(state) {
    state.indexItemsPosition = document.body.scrollTop;
  },
  setCurrentResource(state, resource) {
    state.currentResource = resource;
  },
  addResources(store, data) {
    if (!Array.isArray(data)) {
      data = [data];
    }
    data.forEach((dataResource) => {
      const index = store.state.resources
        .findIndex(storedResource => dataResource.id === storedResource.id);
      if (index + 1) {
        store.state.resources.splice(index, 1, dataResource);
      } else {
        store.state.resources.push(dataResource);
      }
    });
  },
  addNewOffer(state) {
    state.resourceDraft.offers.push(Object.assign({}, offerDefault));
  },
  setResourceDraft(state, resource) {
    state.resourceDraft = resource;
  },
  setResourceDraftCategories(state, categories) {
    state.resourceDraft.categories = categories;
  },
  setOfferDraftPrivacy(state, { index, selectedGroups }) {
    if (!state.resourceDraft.offers) {
      state.resourceDraft.offers = [{}];
    }
    state.resourceDraft.offers[index].group_ids = selectedGroups;
  },
};

export {
  resourceState,
  resourceActions,
  resourceGetters,
  resourceMutations
};
// 225
